export default __webpack_public_path__ + "public/assets/fonts/museoSans/MuseoSans-500.woff2";